import { AnalyticsAdapter, EventBase, UserVars } from '@lifeway/frontend-analytics';
import { FullStory } from '../api/fullStory';

export class FullStoryAdapter implements AnalyticsAdapter {
  constructor(private readonly api: typeof FullStory) {}

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  emit(...events: EventBase<any, any, any>[]): void {
    for (const event of events) {
      this.api.trackEvent({
        name: event.eventType,
        properties: {
          domain: event.domain,
          ...event.context,
        },
      });
    }
  }

  viewPage(pageName: string, properties?: Record<string, unknown>): void {
    this.api.setProperties({ type: 'page', properties: { pageName, ...properties } });
  }

  updatePage(properties?: Record<string, unknown>): void {
    this.api.setProperties({ type: 'page', properties });
  }

  anonymize(): Promise<void> {
    this.api.setIdentity({ anonymous: true });
    return Promise.resolve();
  }

  identify(properties: UserVars): Promise<void> {
    this.api.setIdentity({ properties });
    return Promise.resolve();
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  log(logLevel: number, message: string): void {}
  unloadPage(): void {}
}
